<template>
  <v-card class="p-5">
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="newUser.name"
          append-icon="mdi-account"
          :label="$t('createUserForm.name')"
          outlined
          :error-messages="errors.name"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="newUser.lastName"
          append-icon="mdi-account"
          :label="$t('createUserForm.lastName')"
          outlined
          :error-messages="errors.lastName"
        />
      </v-col>
    </v-row>

    <v-text-field
      v-model="newUser.nid"
      append-icon="mdi-card-account-details-star-outline"
      :label="$t('createUserForm.nid')"
      :maxlength="$i18n.locale === 'fa' ? '10' : '30'"
      outlined
      type="string"
      @keypress="isNumberKey"
      :error-messages="errors.nid"
    />

    <TelInput v-model="newUser.phone" :error-messages="errors.phone" />

    <v-card-actions>
      <v-btn
        :loading="loading"
        class="submit-btn"
        style="width: 100%"
        @click="createUser"
      >
        <span class="fa fa-bookmark icon-md ml-1"></span>
        {{ $t("createUserForm.create") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TelInput from "@/components/TelInput.vue";
import i18n from "@/i18n";

export default {
  name: "CreateUserForm",
  components: { TelInput },
  i18n, // Attach i18n to the component
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      newUser: {
        name: null,
        lastName: null,
        nid: null,
        phone: null,
      },
    };
  },
  methods: {
    isNumberKey(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    createUser() {
      if (!this.newUser.name) {
        this.$emit("error", this.$t("createUserForm.errors.nameRequired"));
        return;
      }
      if (!this.newUser.lastName) {
        this.$emit("error", this.$t("createUserForm.errors.lastNameRequired"));
        return;
      }
      if (!this.newUser.nid) {
        this.$emit("error", this.$t("createUserForm.errors.nidRequired"));
        return;
      }
      if (!this.newUser.phone) {
        this.$emit("error", this.$t("createUserForm.errors.phoneRequired"));
        return;
      }
      this.$emit("create-user", this.newUser);
    },
  },
};
</script>
